import { useTranslation } from 'react-i18next';
import { Icon } from '@bluevision/components';

import styles from './styles.less';

const AdvertisementTip: React.FC = () => {
  const { t } = useTranslation();
  const handleClick = () => {
    window.open(
      'https://www.roibest.com?promoter_id=T035&tpl_id=1&channel_id=18&links_no=7815160877833',
    );
  };
  return (
    <div className={styles.tipsBox}>
      <div className={styles.wrapper} onClick={handleClick}>
        <Icon className={styles.tipIcon} name='trumpet' />
        <div className={styles.tipsWrap}>
          <div className={styles.tipsContent}>{t('google_pkg')}</div>
          <Icon name='arrow-right' />
        </div>
      </div>
    </div>
  );
};
export default AdvertisementTip;
